import { RouterView } from '@/models/enums';

export default {
  methods: {
    isUnregUserView() {
      return this['$route'].name === RouterView.ViewDocUnregUser;
    }
  }
};
